import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import {
  NgModule,
  APP_INITIALIZER,
  Injector
} from '@angular/core';

import {
  HttpClientModule,
  HTTP_INTERCEPTORS
} from '@angular/common/http';

import {
  registerLocaleData
} from '@angular/common';

import localeTr from '@angular/common/locales/tr';
import localeTrExtra from '@angular/common/locales/extra/tr';

import {
  RouterModule,
  DefaultUrlSerializer,
  UrlSerializer,
  UrlTree
} from '@angular/router';

import {
  FormsModule,
  ReactiveFormsModule
} from '@angular/forms';

// Third Party
import { NgxSpinnerModule } from 'ngx-spinner';
import { provideNgxMask } from 'ngx-mask';
import { ModalModule } from 'ngx-bootstrap/modal';

// App
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AppInjector } from './app-injector.service';
import { AppService } from './app.service';
import { HttpInterceptorService } from './core/services/http-interceptor.service';
import { SharedModule } from './shared/shared.module';

import 'src/app/core/utils/string-utils';

registerLocaleData(localeTr, 'tr-TR', localeTrExtra);

export class CustomUrlSerializer extends DefaultUrlSerializer {

  override parse(url: string): UrlTree {
    return super.parse(url);
  }

  override serialize(tree: UrlTree): string {

    return super.serialize(tree)
      .replace(/%3F/g, '?')
      .replace(/%3D/g, '=');
  }
}

export function appFactory(appService: AppService) {
  return () => appService.load();
}

@NgModule({
  declarations: [
    AppComponent
  ],

  imports: [
    BrowserModule,
    BrowserAnimationsModule,

    RouterModule,
    HttpClientModule,

    AppRoutingModule,
    SharedModule,

    FormsModule,
    ReactiveFormsModule,

    NgxSpinnerModule,

    // KRİTİK
    ModalModule.forRoot()
  ],

  providers: [

    AppService,
    AppInjector,

    {
      provide: APP_INITIALIZER,
      useFactory: appFactory,
      deps: [AppService],
      multi: true
    },

    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpInterceptorService,
      multi: true
    },

    provideNgxMask(),

    {
      provide: UrlSerializer,
      useClass: CustomUrlSerializer
    }
  ],

  bootstrap: [AppComponent]
})

export class AppModule {

  constructor(injector: Injector) {

    console.log('Expected #1: storing app injector');

    AppInjector.setInjector(injector);
  }
}